import Vue from 'vue'
import App from './App.vue'
import VueMindmap from 'vue-mindmap'
import vuetify from './plugins/vuetify'
import '@/css/vue-mindmap_cus.css'

Vue.use(VueMindmap)
Vue.prototype.$email = 'bi@afterpay.com'

import router from './router/index'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
